// extracted by mini-css-extract-plugin
module.exports = {"title":"Popup_title__198vi","list":"Popup_list__2S8dD","text":"Popup_text__3dJnV","item":"Popup_item__22eWa","sum":"Popup_sum__3AkEc"};